import { Fragment } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'
import { Spinner } from '@wartek-id/spinner'
import { Shimmer } from '@wartek-id/shimmer'

import {
  SourceUploadDialogPage,
  type SourceUploadDialogPageBaseProps,
} from 'types/kinerja'
import { useAPIGetDocumentsByCategories } from 'api/kinerja/useBuktiKarya'

import type { BuktiKaryaDocumentResponse } from 'types/bukti-karya'
import type { BuktiKaryaCategory } from 'types/kinerja'

interface SourceUploadDialogPage3Props
  extends SourceUploadDialogPageBaseProps<unknown> {
  selectedCategory: BuktiKaryaCategory
  onChange: (file: BuktiKaryaDocumentResponse) => void
  onClose?: Function
}

export default function Page3({
  onSetPage,
  selectedCategory,
  onChange,
  onClose = () => {},
}: SourceUploadDialogPage3Props) {
  const handleSelect = (selectedDocument: BuktiKaryaDocumentResponse) => {
    onChange(selectedDocument)
    onClose()
  }

  const {
    data: documents,
    fetchNextPage,
    hasNextPage,
    isLoading,
  } = useAPIGetDocumentsByCategories(selectedCategory.key)

  return (
    <>
      <div className="flex gap-[6px]">
        <Icon
          onClick={() =>
            onSetPage(SourceUploadDialogPage.BUKTI_KARYA_CATEGORIES)
          }
        >
          arrow_back
        </Icon>

        <div>
          <Text variant="heading-sm">{selectedCategory.name}</Text>
          <Text variant="body" color="subdued">
            {selectedCategory.total} Dokumen
          </Text>
        </div>
      </div>
      {isLoading && (
        <div
          data-testid="loading-spinner-buktikarya"
          className="flex justify-center p-10"
        >
          <Spinner />
        </div>
      )}

      <div className="max-h-96 overflow-auto">
        <InfiniteScroll
          dataLength={documents?.pages[0].meta.total ?? 0}
          next={fetchNextPage}
          hasMore={hasNextPage}
          loader={
            <div className="p-4">
              <Shimmer height={48} className="my-4" style={{ width: '100%' }} />
            </div>
          }
        >
          {documents?.pages?.map((document, groupId) => (
            <Fragment key={groupId}>
              {document.data.map((doc) => (
                <button
                  key={doc.id}
                  className="w-full px-4 py-3 flex gap-3 border-b last:border-0 border-gray-20 cursor-pointer"
                  aria-label={doc.title}
                  onClick={() => handleSelect(doc)}
                >
                  <img
                    src={doc.thumbnailUrl}
                    width={72}
                    height={72}
                    alt={doc.title}
                  />
                  <Text className="!text-left">{doc.title}</Text>
                </button>
              ))}
            </Fragment>
          ))}
        </InfiniteScroll>
      </div>
    </>
  )
}
